/**
 * A Clerk publishable key is `pk_test_` or `pk_live_` followed by base64 of the instance's
 * frontend API host and a trailing `$`. Clerk throws on anything else and the page goes blank,
 * so check first and show a setup message instead.
 */
export const isClerkPublishableKey = (key: string | undefined): boolean => {
  const match = /^pk_(test|live)_([A-Za-z0-9+/=]+)$/.exec(key ?? "");
  if (!match) return false;
  try {
    const decoded = atob(match[2]);
    return decoded.endsWith("$") && decoded.length > 1;
  } catch {
    return false;
  }
};
